import { getPaymentSandboxHeaders } from './helpers/getPaymentSandboxHeaders';
import { Environment } from 'relay-runtime';
import { getEnvironment } from './helpers/relayModernEnvironment';

export function createCheckoutEnvironment({
    getGraphQLNetworkContext,
}: {
    getGraphQLNetworkContext?: () => string | null;
} = {}): Environment {
    return getEnvironment({
        getGraphQLNetworkContext,
        additionalHeaders: getPaymentSandboxHeaders(),
    });
}
